// English (source) UI strings. Keys are grouped by surface.
const en = {
	language: {
		label: 'Language',
		en: 'English',
		es: 'Spanish',
		fr: 'French',
		ar: 'Arabic',
	},
	help: {
		helpMenu: 'Help',
		requestFeature: 'Request a Feature',
		helpDocs: 'Help Docs',
		contactSupport: 'Contact Support',
	},
	nav: {
		dashboard: 'Dashboard',
		cards: 'Cards',
		videoCards: 'Video Cards',
		engagement: 'Engagement',
		settings: 'Settings',
		createNewCard: 'Create new card',
	},
	common: {
		save: 'Save',
		cancel: 'Cancel',
		delete: 'Delete',
		edit: 'Edit',
		search: 'Search',
		loading: 'Loading…',
		download: 'Download',
		share: 'Share',
		close: 'Close',
		back: 'Back',
		next: 'Next',
	},
	viewcard: {
		header: 'Hey %{name}, %{sender} created a digital card for you.',
		hi: 'Hi',
		youHaveACard: 'You have a card!',
		tapEnvelopeToOpen: 'Tap the envelope to open it',
		sentYouACard: '%{sender} sent you a card',
		tapToOpen: '👆 Tap to open',
		tapOrSwipeToFlip: '👆 Tap or swipe to flip your card 👉',
		clickToOpen: 'Click on card to open it.',
		tapToFlip: 'Tap the card to flip it.',
		postcardFront: "Postcard front. Press to flip.",
		postcardBack: "Postcard back. Press to flip.",
		createYourOwn: 'Create your own free card',
		scrollToReact: 'Scroll down to react & comment ↓',
		reactToThisCard: 'React to this card',
		comments: 'Comments',
		leaveComment: 'Leave a comment',
		yourName: 'Your name',
		writeMessage: 'Write a message… (500 chars max)',
		post: 'Post',
		postAnonymously: 'Post anonymously',
		shareToWhatsapp: 'Share to WhatsApp',
		copyLink: 'Copy link',
		linkCopied: 'Link copied!',
		shareViaEmail: 'Share via email',
		shareOnX: 'Share on X',
	},
	music: {
		play: 'Play music',
		pause: 'Pause music',
		volume: 'Volume',
	},
	promo: {
		headline: 'Put a video message inside your cards.',
		subline: 'Let them see and hear you — not just read you. One payment, no subscription.',
		cta: 'Get lifetime access',
		daysLeft: '%{count} days left',
		lastDay: 'Last day',
	},
	unsub: {
		title: 'Email preferences',
		confirmHeading: 'Unsubscribe from these emails?',
		confirmBody: "You'll stop receiving cards and emails from this sender. Nothing else changes.",
		confirmButton: 'Yes, unsubscribe me',
		keepButton: 'No, keep me subscribed',
		processing: 'Updating your preferences…',
		successHeading: "You've been unsubscribed",
		successBody: 'You will no longer receive these emails.',
		successNote: 'Changed your mind? Contact the sender directly and ask them to add you back.',
		keptHeading: "You're still subscribed",
		keptBody: 'No changes were made. You can safely close this page.',
		errorHeading: 'Something went wrong',
		errorBody: "We couldn't process your request. Please try again in a moment.",
		errorMissing: 'This unsubscribe link is incomplete. Please use the link from your email.',
		tryAgain: 'Try again',
	},
};

export default en;
export type TranslationDictionary = typeof en;
